import http from "@/common/http"

export const detail = (id) =>{
  return http({
    url:"/cont/scenic/detail",
    method:"get",
    data:{
      id
    }
  })
}

export const list = (data) =>{
  return http({
    url:"/cont/scenic/list",
    method:"post",
    data:data
  })
}

export default {
  detail,
  list
}



// WEBPACK FOOTER //
// ./src/services/client/cont/scenic.js